module.exports = __webpack_public_path__ + "images/hlj11x5.00a2.png";